import {Shops} from "./types";
import {Platform} from "@variocube/app-api";

export async function getShops(platform: Platform) {
    const shops = await platform.getStorageItem<Shops>("shops");
    if (!shops) {
        console.error("Could not retrieve shops. Will return an empty object");
        return {};
    }
    return shops;
}
